<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1> Induction Program</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="">
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                    <p>GHRCACS, Nagpur, celebrated a vibrant induction program, welcoming new students and introducing them to a world of academic excellence. Welcome to the GHRCACS family! </p>
                    <p>GHRCACS, Nagpur's induction program, was a dynamic event. It set the stage for our new members to integrate seamlessly into the community, fostering collaboration and enthusiasm for future endeavours.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-2.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-2.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <!-- <h6>Activitiy Representers</h6> -->
                          </div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-3.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-3.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-4.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-4.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>   
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-5.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-5.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>     
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-6.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-6.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>   
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-1.avif" data-lightbox="example-set"
                      data-title="GHRCCST GALLERY GLIMPSES">
                      <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-1.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                      <div class="gallery-overlay"></div>   
                    </a>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-7.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/program-7.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                  </div>
              </div>
        </div>
    </div>
</section>